import React from 'react';
import { Box, Grid, IconButton } from '@mui/material';
import { Route } from '@mui/icons-material';
import { TransportationModel } from 'models/TransportationModel';


type DirectionsProps = {
    transportation: TransportationModel,
}

const Directions = ({transportation}: DirectionsProps) => {
    return (
        <Grid container spacing={2} alignItems="center">
            <Grid container item xs={10} sm={11} spacing={2}>
                <Grid item xs={12} sm={6} sx={{textAlign: {sm: 'right'}}}>
                    <Box fontWeight="bold" fontSize=".75rem">
                        {transportation.from.port.name} {transportation.from.name}
                    </Box>
                    {transportation.from.address}
                </Grid>

                <Grid item xs={12} sm={5}>
                    <Box fontWeight="bold" fontSize=".75rem">
                        {transportation.to.port.name} {transportation.to.name}
                    </Box>
                    {transportation.to.address}
                </Grid>
            </Grid>

            <Grid item xs={2} sm={1} textAlign="right">
                <IconButton
                    size="small"
                    component="a"
                    href={`https://www.google.com/maps/dir/?api=1&origin=${transportation.from.address}&destination=${transportation.to.address}&travelmode=driving`}
                    target="_blank"
                >
                    <Route/>
                </IconButton>
            </Grid>
        </Grid>
    );
};

export default Directions;